const component = {

	/**
	 * Init module
	 */
	init: () => {

		window.theme = window.theme || {};
    	window.theme.cart = component;

		component.labels = {
			empty: 'Shopping cart. You do not have any item in your cart.',
			oneitem: 'Shopping cart. You have just one item in your cart.',
			manyItems: 'Shopping cart. You have {{ qty }} items in your cart.'
		};

		component._updateMinicartLabels();
        component._initStandAloneButtons();
        //component._initAddToCartForms();
	},

	/**
	 * Init stand alone add to cart button
	 */
	_initStandAloneButtons: () => {

		let buttons = document.querySelectorAll('[data-cart-add]');

		buttons.forEach(btn => {
			btn.addEventListener('click', event => {

				let button = event.target;

				button.setAttribute('disabled', true);

				component.add(button.dataset.cartAdd, button.dataset.cartAddQty, button.dataset.cartAddProp).then(result => {
					button.removeAttribute('disabled');
				});
			});
		});
	},

	/**
	 * Reload minicart data
	 */
	_reloadMinicart: () => {

		return new Promise((resolve, reject) => {

			fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' }).then(function(response) {
				return response.json();
			}).then(function(cart) {
	
				component._setCartQuantity(cart.item_count);

				resolve(cart);
	
			}).catch(function(error) {
				console.log(error);
			});
		});
	},

	/**
	 * Update cart quantity counters
	 */
	_setCartQuantity: (quantity) => {

		document.querySelectorAll('[data-minicart-count]').forEach(counter => {
			counter.innerText = quantity;
			counter.dataset.minicartCount = quantity;
		});
	},

	/**
	 * Get cart quantity
	 */
	getCartQuantity: () => {

		let count = document.querySelector('[data-minicart-count]');

		if (count) {
			
			return parseInt(count.dataset.minicartCount);

		} else {

			return 0;
		}
	},

	/**
	 * Add a product to the cart by parameters
	 */
	add: (id, qty, properties) => {

		return new Promise((resolve, reject) => {

			// Create the request
			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({
					id: id,
					quantity: qty
				})
			};

			// Make a request
			fetch(window.Shopify.routes.root +  'cart/add.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {

				if (json.status && json.status !== 200) {
					var error = new Error(json.description);
					error.isFromServer = true;
					throw error;
				}

				component._afterAddToCart(0);
				resolve(true);
				
			}).catch(function(error) {
				reject(error);
			});
		});
	},

	/**
	 * Update a product to the cart by parameters
	 */
	 update: (id, qty, properties) => {

		return new Promise((resolve, reject) => {

			// Create the request
			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({
					id: id,
					quantity: qty
				})
			};

			// Make a request
			fetch(window.Shopify.routes.root + 'cart/change.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {

				if (json.status && json.status !== 200) {
					const error = new Error(json.description);
					const max_quantity = json.description.match(/(\d+)/g)[0];

					if (max_quantity) {
						document.querySelectorAll(`input[data-cart-table-item-id="${id}"]`).forEach(el => el.value = max_quantity);
					}

					alert(json.description);
					error.isFromServer = true;
					throw error;
				}

				resolve(true);
				
			}).catch(function(error) {
				reject(error);
			});
		});
	},

	/**
	 * Add a product to the cart by form data
	 */
	addByForm: form => {

		return new Promise((resolve, reject) => {

			// Check if the serialize function is available
			if (typeof window.theme.serialize != 'undefined') {

				// Create the request
				let request = {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
					  'Content-Type': 'application/x-www-form-urlencoded',
					  'X-Requested-With': 'XMLHttpRequest'
					},
					body: window.theme.serialize.serializeForm(form)
				}

				// Make a request
				fetch(window.Shopify.routes.root + 'cart/add.js', request).then(function(response) {
					return response.json();
				}).then(function(json) {

					if (json.status && json.status !== 200) {
						var error = new Error(json.description);
						error.isFromServer = true;
						throw error;
					}

					var qty_added = form.querySelector("input[name='quantity']");

					if(qty_added) {
						component._afterAddToCart(qty_added.value);
					}
					
					resolve(true);
					  
				}).catch(function(error) {
					reject(error);
				});

			} else {

				reject(false);
			}
		});
	},

	/**
	 * After add to cart
	 * 
	 * @param {integer} qty_added Product quantity added to the cart.
	 */
	_afterAddToCart: (qty_added) => {
		component._reloadMinicart().then((cart) => {
			component._updateMinicartLabels();
			window.theme.mini_cart._openMinicart(qty_added);
		});
	},

	/**
	 * Update minicart labels for web accessibility
	 */
	_updateMinicartLabels: () => {

		let quantity = component.getCartQuantity();

		document.querySelectorAll('[data-minicart-toggle]').forEach(toggle => {

			if (quantity > 0) {

				if (quantity == 1) {

					toggle.setAttribute('aria-label', component.labels.oneitem);

				} else {

					toggle.setAttribute('aria-label', component.labels.manyItems.replace('{{ qty }}', quantity));
				}

			} else {

				toggle.setAttribute('aria-label', component.labels.empty);
			}
		});
	},

	_validateFieldRequired: form => {
		const fields = form.querySelectorAll("[required]");
		let foundError = false;

		for( let field of fields ){
			foundError = field.validity.valueMissing;

			if(foundError){
				field.classList.add("invalid");
			}
		}

		return foundError;
	}
};

export default component;